(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	function btyHeaderSticky( doc = document ) {
		let hasTopbar = document.querySelector( '.topbar-section ~ .header-section' ),
			header    = doc.querySelector( '.header.transparent-header' );

		function onShopifyLoaded( callback ) {
			if ( ! header ) {
				setTimeout(
					function() {
						onShopifyLoaded( callback )
					}
				);

				return;
			}

			callback();
		}

		onShopifyLoaded(
			function() {
				if ( ! header ) {
					return;
				}

				const detectScroll = function() {
					if ( window.scrollY > 50 ) {
						header.classList.add( 'is-sticky' );
					} else {
						header.classList.remove( 'is-sticky' );
					}
				}

				if ( Shopify.designMode || ! hasTopbar ) {
					detectScroll();
					window.addEventListener( 'scroll', detectScroll );
				} else {
					const observer = new IntersectionObserver(
						([e]) => e.target.classList.toggle( 'is-sticky', e.intersectionRatio < 1 ),
						{
							rootMargin: '-1px 0px 0px 0px',
							threshold: [1]
						}
					);

					observer.observe( header );
				}
			}
		)
	}

	btyHeaderSticky();

	document.addEventListener(
		'shopify:section:select',
		function( e ) {
			let section = e.target;
			btyHeaderSticky( section );
		}
	);

	document.addEventListener(
		'shopify:block:select',
		function( e ) {
			let section = document.getElementById( 'shopify-section-' + e.detail.sectionId );
			btyHeaderSticky( section );
		}
	);

  } catch(e) { console.error(e); }
})();
})();
